
import { Vue, Component, Prop } from "vue-property-decorator";
import ChipWithLinkData from "@/types/ChipWithLinkData";
import ChipWithLink from "@/components/common/ChipWithLink.vue";

@Component({
    components: {
        ChipWithLink
    }
})
export default class ChipsWithMore extends Vue {
    @Prop({ type: Array, default: () => [] }) readonly chipWithLinkDatas!: ChipWithLinkData[];
    @Prop({ type: Number, default: 0 }) readonly limit!: number;
    @Prop({ type: Boolean, default: false }) readonly wrapChips!: boolean;

    extra: number = this.chipWithLinkDatas.length && this.limit ? this.chipWithLinkDatas.length - this.limit : Number(0);
    variant = this.chipWithLinkDatas.length ? this.chipWithLinkDatas[0].variant : 'default';
}
